module.exports = __webpack_public_path__ + "assets/img/mecha5-8ed84b1f.jpg";